export enum CRReportType {
  Detail = 'detail',
  Summary = 'summary',
  OnePage = 'one-page',
  Winsupply = 'winsupply',
  NetworkDetail = 'network-detail',
  NetworkSummary = 'network-summary',
  AlliedOms = 'allied-oms'
}

export const levelMapper: Record<CRReportType, number> = {
  [CRReportType.Summary]: 1,
  [CRReportType.Detail]: 2,
  [CRReportType.NetworkSummary]: 3,
  [CRReportType.NetworkDetail]: 4,
  [CRReportType.OnePage]: 5,
  [CRReportType.Winsupply]: 6,
  [CRReportType.AlliedOms]: 7
}

export const mapper: Record<CRReportType, string> = {
  [CRReportType.Detail]: 'Detail',
  [CRReportType.Summary]: 'Summary',
  [CRReportType.OnePage]: 'One Page',
  [CRReportType.Winsupply]: 'Winsupply',
  [CRReportType.NetworkDetail]: 'Network Detail',
  [CRReportType.NetworkSummary]: 'Network Summary',
  [CRReportType.AlliedOms]: 'Allied OMS'
}

export const label = (
  type: CRReportType,
  options?: {
    includeDiagnosisDetails: boolean
    includePHI: boolean
  }
): string => {
  const base = mapper[type]
  if (!options) return base

  switch (type) {
    case CRReportType.Detail: {
      switch (true) {
        case options.includeDiagnosisDetails && !options.includePHI: {
          return `${base} with Diagnosis and Patient Redacted`
        }
        case options.includeDiagnosisDetails: {
          return `${base} with Diagnosis`
        }
        case !options.includePHI: {
          return `${base} Patient Redacted`
        }
        default: {
          return base
        }
      }
    }
    default: {
      return base
    }
  }
}
interface DetailReportConfig {
  id: string
  type: CRReportType.Detail
  options: {
    includeDiagnosisDetails: boolean
    includePHI: boolean
  }
}

interface OptionlessReportConfig {
  id: string
  type: Exclude<CRReportType, CRReportType.Detail>
}

export type ReportConfig = DetailReportConfig | OptionlessReportConfig
